import { RUN_WIZARD_ACTION_ASYNC, SAVE_PSA_INTEGRATION_ASYNC } from './constants'

export const REDACTED_PAYLOAD = '[redacted: may carry PSA credentials]'

// These requests carry the secret the user typed, and Redux DevTools records every action.
const CREDENTIAL_CARRYING_TYPES = new Set([
  RUN_WIZARD_ACTION_ASYNC.INITIATE,
  SAVE_PSA_INTEGRATION_ASYNC.INITIATE,
])

export const sanitizePSAWizardAction = (action) =>
  CREDENTIAL_CARRYING_TYPES.has(action.type) ? { ...action, payload: REDACTED_PAYLOAD } : action
